import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-delete-element',
  templateUrl: './delete-element.component.html',
})
export class DeleteElementComponent implements OnInit {
  private element: any;
  public elementType: string;
  private lastRoute: string;
  private apiRoute: string;
  private onSuccess: (() => void) | null = null;

  env: string;

  constructor(
    private bsModalRef: BsModalRef,
    private apiService: ApiService,
    private toastr: ToastrService,
    private router: Router
  ) { }

  ngOnInit(): void {
    console.log(this.element);
    switch (this.elementType) {
      case 'venue':
        this.env = environment.apiVenuesUrl;
        break;
      case 'contentdistribution':
        this.env = environment.contentdistribution.private.url;
        break;
      default:
        this.env = environment.apiAuthUrl;
        break;
    }
    console.log(this.env);
  }

  public onDismiss() {
    this.bsModalRef.hide();
  }

  public onSubmit() {
    this.apiRoute = this.env + this.apiRoute;
    this.apiService.deleteElement(this.apiRoute, this.element.id).subscribe(
      response => {
        this.onSuccess?.();
        if (this.lastRoute) {
          this.router.navigate([this.lastRoute]);
        }
        this.onDismiss();
        this.toastr.success('', 'Deleted item');
      },
      error => {
        console.error(error);
        this.toastr.error('', 'An error has occurred');
      }
    );
  }
}
